import { lazy, Suspense } from 'react';
import { AdminLayout } from 'components/themes/admin';

const AdminJobs = lazy(() => import('modules/admin/Job/AdminJobs'));

const AdminJobsPage = (props) => (
  <AdminLayout>
    <Suspense fallback={null}>
      <AdminJobs />
    </Suspense>
  </AdminLayout>
);

export default AdminJobsPage;
